import { AutomBomba } from './../interfaces/autom-bomba';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { UnMedida } from '../interfaces/un-medida';
import { JwtAuthService } from './auth/jwt-auth.service';
import { AutomReceitaEnums } from '../interfaces/autom-receita-enums';

@Injectable({
  providedIn: 'root'
})
export class AutomBombaService {

  readonly path = '/autom/bomba';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  create(): Observable<AutomBomba> {
    return this.http.post<AutomBomba>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(tanque: AutomBomba): Observable<AutomBomba> {
    return this.http.put<AutomBomba>(`${this.jwtAuthService.apiUrl + this.path}`, tanque);
  }

  getBomba(id: number ): Observable<AutomBomba> {
    return this.http.get<AutomBomba>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getombaPage(page?: number, size?: number, order = 'NENHUM', direction = 'ASC'): Observable<PageResult<AutomBomba>> {
    return this.http.get<PageResult<AutomBomba>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getBombaPageSearch(page?: number, size?: number,  search?: string,
    order = 'NENHUM', direction = 'ASC'): Observable<PageResult<AutomBomba>> {
    return this.http.get<PageResult<AutomBomba>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  deleteBomba(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

 
}
